<template>
  <div>
    <!-- <input v-model="name" class="form-control" placeholder="New Category"> -->
    <button @click="showModal">
      New Category
      <i class="material-icons action-icon">add</i>
    </button>
  </div>
</template>

<script>
import db from "../db.js";
import eventHub from "../eventHub.js";

export default {
  name: "new-category",
  data() {
    return {
      name: "",
    };
  },
  methods: {
    showModal() {
      let payload = Object.assign({ modalType: "new" }, { name: this.name });
      eventHub.$emit("show-category-modal", payload);
      this.$set(this, "name", "");
    },
  },
};
</script>

<style scoped>
/* FIXME - BETTER POSITIONING PLEASE */
button {
  /*background: #3498db;*/
  /*border: none;*/
  background: transparent;
  border: 1px solid #ddd;
  color: #2c3e50;
  padding: 0.5rem;
  padding-top: 0.125rem;
  /*color: white;*/
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.5s;
}

.action-icon {
  transition: all 0.5s;
}

/* FIXME - Eventually this should be accessible... */
button:focus {
  outline: none;
}

button:hover .action-icon,
button:focus .action-icon {
  /*color: inherit;*/
  color: white;
}

button:hover,
button:focus {
  background: #3498db;
  color: white;
}

.material-icons.action-icon {
  /*color: white;*/
  color: #2c3e50;
  font-size: 1rem;
  position: relative;
  top: 0.25rem;
}

.material-icons.action-icon:hover {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// NewCategory.vue?552bcd11